module.exports = {
          srcSet: __webpack_public_path__ + "public/images/71c6035aca21dd0608eff3735efba2e5-380.webp"+" 380w",
          images:[ {path: __webpack_public_path__ + "public/images/71c6035aca21dd0608eff3735efba2e5-380.webp",width: 380,height: 253}],
          src: __webpack_public_path__ + "public/images/71c6035aca21dd0608eff3735efba2e5-380.webp",
          toString:function(){return __webpack_public_path__ + "public/images/71c6035aca21dd0608eff3735efba2e5-380.webp"},
          
          width: 380,
          height: 253
        }